import ArticleLayout from "../components/ArticleLayout";

export default function SafetyGuide() {
  return <ArticleLayout articleId={14} />;
}